// brazilV2TabConfig.ts
// ─── Astria Brazil v2 — per-tab wizard field structure ─────────────────────
// Per client spec (BrMaxico.txt — BR v2 Full Specification / UI JSON Pack):
// 6 tabs, each a SINGLE screen (not a multi-step wizard) with 1-2 input
// controls, submitted immediately. Field keys here map 1:1 onto the
// `brazilV2Wizard` req.body object the backend expects (see
// helper/astriaBrazilV2Service.js / philippinesIndonesiaV2Shared.js header
// comments for the contract).
//
// This file holds only the LANGUAGE-NEUTRAL structure (tab, icon, field
// key/type, chip option values). All displayed text (questions, helper
// copy, field labels, chip option labels) lives in brazilV2Copy.ts, keyed
// by language — see BrazilV2Tab.tsx for how the two are merged.
import { AstriaBrazilV2Tab } from "./AstriaBrazilV2Shell";

export type BrazilV2FieldType =
  | "emoji_wheel"
  | "slider"
  | "chips"
  | "multi_select"
  | "text";

export interface BrazilV2FieldConfig {
  key:
    | "mood"
    | "intensity"
    | "connection"
    | "tone"
    | "flow"
    | "readiness"
    | "emotion_zone"
    | "location"
    | "issue"
    | "desired"
    | "latest_message"
    | "feeling";
  type: BrazilV2FieldType;
  optionValues?: string[];
}

export interface BrazilV2TabConfig {
  tab: AstriaBrazilV2Tab;
  icon: string; // emoji, per client spec
  fields: BrazilV2FieldConfig[];
}

export const BRAZIL_V2_TAB_CONFIGS: BrazilV2TabConfig[] = [
  {
    tab: "soft_summary",
    icon: "🌙",
    fields: [
      { key: "mood", type: "emoji_wheel" },
      { key: "intensity", type: "slider" },
    ],
  },
  {
    tab: "connection_atmosphere",
    icon: "💛",
    fields: [
      {
        key: "connection",
        type: "chips",
        optionValues: ["warm", "distant", "tense", "playful", "quiet"],
      },
      {
        key: "tone",
        type: "chips",
        optionValues: ["gentle", "guarded", "open", "unsure"],
      },
    ],
  },
  {
    tab: "timing_rhythm",
    icon: "⏳",
    fields: [
      {
        key: "flow",
        type: "chips",
        optionValues: ["slow", "steady", "rushed", "uncertain"],
      },
      { key: "readiness", type: "slider" },
    ],
  },
  {
    tab: "emotion_balance",
    icon: "🌤️",
    fields: [
      {
        key: "emotion_zone",
        type: "chips",
        optionValues: ["warm", "heavy", "light", "tender", "steady"],
      },
      {
        key: "location",
        type: "chips",
        optionValues: ["chest", "mind", "stomach", "everywhere"],
      },
    ],
  },
  {
    tab: "guidance_path",
    icon: "🧭",
    fields: [
      {
        key: "issue",
        type: "chips",
        optionValues: ["communication", "distance", "uncertainty", "overwhelm"],
      },
      {
        key: "desired",
        type: "chips",
        optionValues: ["clarity", "closeness", "peace", "courage"],
      },
    ],
  },
  {
    tab: "your_note",
    icon: "📝",
    fields: [
      { key: "latest_message", type: "text" },
      {
        key: "feeling",
        type: "chips",
        optionValues: ["soft", "hopeful", "unsure", "relieved"],
      },
    ],
  },
];
